import React from "react";
import IconThemePreviewBase from "./IconThemePreviewBase";

function SystemPrefIcon() {
  return (
    <IconThemePreviewBase sidebarPathFill="#38A6DE"
      maskContent={
        <>
          <mask
            id="mask0_831_53663"
            style={{ maskType: "alpha" }}
            width="95"
            height="136"
            x="94"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#D9D9D9" d="M94 0H189V136H94z" />
          </mask>
          <g mask="url(#mask0_831_53663)">
            <rect
              width="189"
              height="136"
              x="0.5"
              y="0.5"
              fill="#1B232E"
              stroke="#ECEEF5"
              rx="4.5"
            />
            <path fill="#080A0B" d="M54 136h132a3 3 0 003-3V14H54v122z" />
            <g filter="url(#filter5_d_831_53663)">
              <path
                fill="#1B2028"
                d="M1 11C1 5.477 5.477 1 11 1h168c5.523 0 10 4.477 10 10v4H1v-4z"
              />
            </g>
            <path fill="#2E343F" d="M1 14a1 1 0 001 1h186a1 1 0 001-1H1z" />
            <g filter="url(#filter6_d_831_53663)">
              <rect width="40" height="16" x="59" y="31" fill="#1B232E" rx="1" />
            </g>
            <rect width="34" height="4" x="62" y="40" fill="#27303B" rx="1" />
            <g filter="url(#filter7_d_831_53663)">
              <rect width="125" height="80" x="59" y="52" fill="#1B232E" rx="1" />
            </g>
            <g filter="url(#filter8_d_831_53663)">
              <rect width="40" height="16" x="102" y="31" fill="#1B232E" rx="1" />
            </g>
            <rect width="4" height="4" x="105" y="34" fill="#88959B" rx="1" />
            <rect width="34" height="4" x="105" y="40" fill="#27303B" rx="1" />
            <g filter="url(#filter9_d_831_53663)">
              <rect width="40" height="16" x="144" y="31" fill="#1B232E" rx="1" />
            </g>
            <rect width="4" height="4" x="147" y="34" fill="#88959B" rx="1" />
            <rect width="34" height="4" x="147" y="40" fill="#27303B" rx="1" />
            <rect width="21" height="4" x="123" y="55" fill="#252E39" rx="1" />
            <rect width="21" height="4" x="123" y="75" fill="#252E39" rx="1" />
            <rect width="58" height="7" x="62" y="61" fill="#27303B" rx="2" />
            <rect width="58" height="7" x="62" y="81" fill="#27303B" rx="2" />
            <rect width="119" height="28" x="62" y="101" fill="#27303B" rx="2" />
            <rect width="58" height="7" x="123" y="61" fill="#27303B" rx="2" />
            <rect width="58" height="7" x="123" y="81" fill="#27303B" rx="2" />
          </g>
        </>
      }
    >
      {/* Main content for SystemPrefIcon (light part) */}
      <g filter="url(#filter1_d_831_53663)">
        <rect width="40" height="16" x="59" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="62" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="62" y="40" fill="#ECF1F5" rx="1" />
      <g filter="url(#filter2_d_831_53663)">
        <rect width="125" height="80" x="59" y="52" fill="#fff" rx="1" />
      </g>
      <g filter="url(#filter3_d_831_53663)">
        <rect width="40" height="16" x="102" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="105" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="105" y="40" fill="#ECF1F5" rx="1" />
      <g filter="url(#filter4_d_831_53663)">
        <rect width="40" height="16" x="144" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="147" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="147" y="40" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="55" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="75" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="95" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="123" y="55" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="123" y="75" fill="#ECF1F5" rx="1" />
      <rect width="57.7" height="6.7" x="62.15" y="61.15" stroke="#CCC" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="62.15" y="81.15" stroke="#CCC" strokeWidth="0.3" rx="1.85" />
      <rect width="118.7" height="27.7" x="62.15" y="101.15" stroke="#CCC" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="123.15" y="61.15" stroke="#CCC" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="123.15" y="81.15" stroke="#CCC" strokeWidth="0.3" rx="1.85" />
      <defs>
        {/* All filters from the original SVG */}
        <filter id="filter1_d_831_53663" width="44" height="20" x="57" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter2_d_831_53663" width="129" height="84" x="57" y="51" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter3_d_831_53663" width="44" height="20" x="100" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter4_d_831_53663" width="44" height="20" x="142" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        {/* ...other filters from the original SVG... */}
        <filter id="filter5_d_831_53663" width="190" height="16" x="0" y="1" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter6_d_831_53663" width="44" height="20" x="57" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter7_d_831_53663" width="129" height="84" x="57" y="51" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter8_d_831_53663" width="44" height="20" x="100" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
        <filter id="filter9_d_831_53663" width="44" height="20" x="142" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_831_53663" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_831_53663" result="shape" />
        </filter>
      </defs>
    </IconThemePreviewBase>
  );
}

export default SystemPrefIcon;
